module.exports = __webpack_public_path__ + "img/logo_199.376ce212.png";